var exports = {
  "az": "Box__pIkMkv",
  "wy": "Box_1__1bJV7g",
  "DL": "Box_1_stickied__HMn8TB",
  "pv": "Box_2__Is-e-Y",
  "w9": "Box_3__OE5Y7F",
  "pQ": "Box_4__C-NqPq",
  "K0": "IconButton__0qsoRg",
  "rq": "ActionMenu_Overlay__0098nC",
  "ws": "Box_5__JL7bhO",
  "D6": "Box_6__uNKY61",
  "z9": "LinkButton___5BTHO",
  "Pl": "IconButton_2__S3zcZt",
  "l6": "downloadButton__gSQP8w",
};

module.exports = exports;
